import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import Head from 'next/head';

import { loadVideo } from 'redux/modules/video';
import { setPageView, setVertical } from 'redux/modules/shared';

import { video as videoPropType } from 'lib/CustomPropTypes';

import AdsBundle from 'components/AdsBundle';
import AnalyticsLaunchScripts from 'components/AnalyticsLaunchScripts';
import InlineVideo from 'components/InlineVideo';
import IconfontStyleTag from 'components/IconfontStyleTag';
import { HeaderAndFooter } from 'components/services/HeaderAndFooter';
import { layout as servicesLayoutPropType } from 'lib/CustomPropTypes/services';
import ErrorPage from '../_error';

import 'assets/stylesheets/main.scss';
import 'assets/stylesheets/toolkit.scss';
import styles from './videoEmbed.module.scss';
import globalContainerStyles from '../globalContainerStyles.module.scss';


const mapStateToProps = ({
  video,
}) => ({
  nowPlaying: video.current,
});

class VideoEmbedPage extends Component {
  static async getInitialProps(ctx) {
    const {
      params: {
        id,
        vertical: verticalFromRoute,
      },
      query: {
        autoplay: autoPlay,
      },
    } = ctx.req;
    const {
      locals: {
        vertical: parsedVertical,
        services,
      },
    } = ctx.res;
    const { store } = ctx;

    const promises = [
      store.dispatch(loadVideo(id, verticalFromRoute)),
      store.dispatch(setPageView('embedded-video')),
    ];

    if (verticalFromRoute) {
      promises.push(store.dispatch(setVertical(verticalFromRoute)));
    }

    await Promise.all(promises);

    // Populate props with HFS component data
    const layout = {};
    if (services && services.layout && services.layout.getComponent) {
      layout.header = await services.layout.getComponent(parsedVertical, 'header');
      layout.footer = await services.layout.getComponent(parsedVertical, 'footer');
    }

    const storeState = store.getState();
    const { video } = storeState;
    const { current } = video;

    const { status: statusCode } = current.error ? current.error : { statusCode: 200 };
    if (statusCode >= 400) {
      ctx.res.statusCode = statusCode;
    }

    if (!verticalFromRoute) {
      // verify the vertical for the embedded video if the vertical is not defined
      // by url: www.today.com/embedded-video/mmvo62780997696
      const slug = get(storeState, 'video.current.taxonomy.primaryVertical.slug',
      // if no vertical found, use vertical parsed from url as default
      // vertical parsed from url will be the vertical for the domain as a fallback
        parsedVertical);
      await store.dispatch(setVertical(slug));
    }

    return {
      autoPlay,
      layout,
      statusCode,
      vertical: parsedVertical,
    };
  }

  static propTypes = {
    layout: servicesLayoutPropType.isRequired,
    autoPlay: PropTypes.bool,
    nowPlaying: videoPropType.isRequired,
    themesCssPath: PropTypes.string,
    vertical: PropTypes.string,
    statusCode: PropTypes.number,
  };

  static defaultProps = {
    autoPlay: false,
    vertical: '',
    themesCssPath: '',
    statusCode: 200,
  };

  render() {
    const {
      autoPlay,
      layout,
      vertical,
      nowPlaying,
      statusCode,
      themesCssPath,
    } = this.props;

    if (nowPlaying.error) {
      return (
        <HeaderAndFooter layout={layout}>
          <ErrorPage statusCode={statusCode === 404 ? 404 : 500} vertical={vertical} />
        </HeaderAndFooter>
      );
    }

    return (
      <>
        <Head>
          <meta name="robots" content="noindex" key="robots" />
          {themesCssPath && (
            <link href={themesCssPath} rel="stylesheet" key={themesCssPath} />
          )}
          <IconfontStyleTag />
        </Head>

        <div className={globalContainerStyles.container}>
          <div className={`df items-center justify-center ${styles.embeddedWrapper}`}>
            <div className={styles.playerWrapper}>
              <InlineVideo
                autoPlay={autoPlay}
                isEmbedded
                mute={autoPlay}
                video={nowPlaying}
              />
            </div>
          </div>
        </div>

        <AnalyticsLaunchScripts />
        <AdsBundle />
      </>
    );
  }
}

export default connect(mapStateToProps)(VideoEmbedPage);
